/* eslint-disable */
const ls = require('local-storage');

import * as types from './mutation-types';

export default {
  /**
  * Login
  */
  [types.LOGIN](state, { userToken, user }) {
    state.authenticated = true;
    state.user = user;
    state.userToken = userToken;
    ls.set('userToken', userToken);
  },
  /**
  * Logout
  */
  [types.LOGOUT](state) {
    state.authenticated = false;
    state.user = null;
    state.userToken = null;
    ls.remove('userToken');
  },
  /**
  * Update user data
  */
  [types.UPDATE_USER](state, { user, authenticated }) {
    /**
    * Set user to null allows to be sure that changes are detected by the scope
    */
    state.user = null;
    state.user = user;
    // state.authenticated = authenticated;
  },

  [types.GET_USERS](state, users) {
   /**
    * get users list
    */
   state.users = users;
 },

  [types.SET_USER_GUIDE](state, userGuide) {
   /**
    * get users list
    */
   state.userGuide = userGuide;
 },

  SET_USER_PROFILE(state, profile) {
    state.userProfile = null;
    state.userProfile = profile;
  }
};
